export default "__VITE_ASSET__aOERQTaQ__"